import { render, staticRenderFns } from "./CardSkeletonLoader.vue?vue&type=template&id=229b1674"
import script from "./CardSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./CardSkeletonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports